import React from 'react';
import { StepConfigItem } from '~/Interfaces';
import { isInIframe } from '~/iframeMode';
import { AdditionalInformation } from './components/AdditionalInformation/AdditionalInformation';
import { AdditionalInformationFooter } from './components/AdditionalInformation/components/AdditionalInformationFooter';
import { StartApplication } from './components/StartApplication/StartApplication';
import { StartApplicationFooter } from './components/StartApplication/components/StartApplicationFooter';

const StartApplicationStep: StepConfigItem = {
  component: StartApplication,
  customFooter: StartApplicationFooter,
  customHeader: isInIframe ? () => <></> : undefined,
  header: {
    title: 'CardApplication.StartApplicationStepTitle',
    description: 'CardApplication.StartApplicationStepDescription',
  },
  name: 'start_application_step',
};

const AdditionalInformationStep: StepConfigItem = {
  component: AdditionalInformation,
  customFooter: AdditionalInformationFooter,
  customHeader: isInIframe ? () => <></> : undefined,
  header: {
    title: 'CardApplication.AdditionalInformationStepTitle',
    description: 'CardApplication.AdditionalInformationStepDescription',
  },
  name: 'additional_information_step',
};

export const cardApplicationSteps = [
  StartApplicationStep,
  AdditionalInformationStep,
];
